import BaseCheckbox, { type CheckboxProps as BaseCheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel, { type FormControlLabelProps } from '@mui/material/FormControlLabel';
import { forwardRef } from 'react';

import { mergeSx } from '../../utils';

type CheckboxProps = BaseCheckboxProps & {
  label?: FormControlLabelProps['label'];
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  slotProps?: {
    formControlLabel?: Omit<FormControlLabelProps, 'control' | 'label' | 'slotProps'>;
  } & FormControlLabelProps['slotProps'];
};

const Checkbox = forwardRef((props: CheckboxProps, ref) => {
  const {
    label,
    labelPlacement,
    value,
    required: isRequired,
    slotProps = {},
    onChange,
    ...restProps
  } = props;
  const { formControlLabel: formControlLabelProps, ...restSlotProps } = slotProps;
  const additionalLabelSx = mergeSx(formControlLabelProps?.sx, {
    '&.MuiFormControlLabel-root': {
      m: 0,
    },
  });

  return (
    <FormControlLabel
      {...formControlLabelProps}
      ref={ref}
      control={
        <BaseCheckbox
          checked={!!value}
          value={value}
          sx={{
            color: isRequired ? 'error.main' : undefined,
          }}
          onChange={onChange}
          {...restProps}
        />
      }
      sx={additionalLabelSx}
      label={label}
      labelPlacement={labelPlacement}
      slotProps={restSlotProps}
    />
  );
});

Checkbox.displayName = 'Checkbox';

export { Checkbox };
export type { CheckboxProps };
